import { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp, FaSearch, FaTrash } from "react-icons/fa";
import "./_User.scss";
import "./_UserMobile.scss";
import { useMediaQuery } from "react-responsive";

function _User() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [keyword, setKeyword] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [openRow, setOpenRow] = useState(null);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      setHeight(openRow ? "200px" : "0px");
    }
  }, [openRow]);
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/user/get-all-user`,
      );
      const data = await res.json();
      setUsers(data.user);
      setFilteredUsers(data.user);
    } catch (err) {
      console.error(err);
    }
  };

  // Filter logic
  const handleSearch = (value) => {
    setKeyword(value);

    const lower = value.toLowerCase();

    const filtered = users.filter(
      (u) =>
        `${u.CP_Firstname} ${u.CP_Lastname}`.toLowerCase().includes(lower) ||
        u.CP_Emailaddress?.toLowerCase().includes(lower) ||
        u.CP_Contactnumber?.toLowerCase().includes(lower),
    );

    setFilteredUsers(filtered);
  };
  const dateFormatted = (date) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${month}/${day}/${year}`;
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/user/delete/${id}`,
        { method: "DELETE" },
      );

      const data = await res.json();

      if (res.ok) {
        // Remove deleted user from UI without refreshing
        const updated = users.filter((u) => u.CP_ID !== id);
        setUsers(updated);
        setFilteredUsers(updated);
      } else {
        alert(data.error || "Delete failed.");
      }
    } catch (err) {
      console.error(err);
      alert("Error deleting user.");
    }
  };

  const getProfileImage = (path) => {
    if (!path || path === "default-profile-pic") {
      return "/Assets/Profile/default-profile-pic.png";
    }

    // Full external URL (Google, Facebook, etc.)
    if (path.startsWith("http")) {
      return path;
    }

    // Google image ID (not real local file)
    if (path.includes("=") && path.length > 50) {
      return `https://lh3.googleusercontent.com/a/${path}`;
    }

    // Local uploaded image
    return `/Assets/Profile/${path}`;
  };
  return (
    <main className="ad-user-panel-container">
      <div className="panel-header">
        <div className="title-wrapper">
          <span>USERS LIST</span>
        </div>

        <div className="actions-wrapper">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Keyword..."
              value={keyword}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <span>
              <FaSearch />
            </span>
          </div>
        </div>
      </div>

      {!isMobile ? (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Photo</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Birth Day</th>
                <th>Gender</th>
                <th>Contact Number</th>
                <th>Email</th>
                <th>Account Provider</th>
                <th>Date Created</th>
                <th>ACTIONS</th>
              </tr>
            </thead>

            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((u, index) => (
                  <>
                    <tr key={u.CP_ID}>
                      <td>{index + 1}</td>

                      <td>
                        <img
                          src={getProfileImage(u.CP_Profilepicpath)}
                          alt="profile"
                        />
                      </td>

                      <td>{u.CP_Firstname}</td>
                      <td>{u.CP_Lastname}</td>
                      <td>{dateFormatted(u.CP_Birthdate)}</td>
                      <td>
                        {u.CP_Gender === "other"
                          ? "Prepare not to say"
                          : u.CP_Gender}
                      </td>
                      <td>{u.CP_Contactnumber}</td>
                      <td>{u.CP_Emailaddress}</td>
                      <td>{u.CP_Provider}</td>
                      <td>{dateFormatted(u.CP_CreatedAt)}</td>

                      <td>
                        <div className="td-action-btns-wrapper">
                          <FaTrash
                            className="action-icon delete"
                            title="Delete"
                            onClick={() => handleDelete(u.CP_ID)}
                          />
                        </div>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="11"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Photo</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>ACTIONS</th>
              </tr>
            </thead>

            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((u, index) => (
                  <>
                    <tr key={u.CP_ID}>
                      <td
                        className="td-toggle-icon"
                        onClick={() => {
                          setOpenRow(openRow === u.CP_ID ? null : u.CP_ID);
                        }}
                      >
                        {openRow === u.CP_ID ? (
                          <FaChevronUp
                            className="toggle-icon"
                            title="Collapse"
                          />
                        ) : (
                          <FaChevronDown
                            className="toggle-icon"
                            title="Expand"
                          />
                        )}
                      </td>

                      <td>
                        <img
                          src={getProfileImage(u.CP_Profilepicpath)}
                          alt="profile"
                        />
                      </td>

                      <td>{u.CP_Firstname}</td>
                      <td>{u.CP_Lastname}</td>
                      <td>{u.CP_Emailaddress}</td>

                      <td>
                        <div className="td-action-btns-wrapper">
                          <FaTrash
                            className="action-icon delete"
                            title="Delete"
                            onClick={() => handleDelete(u.CP_ID)}
                          />
                        </div>
                      </td>
                    </tr>{" "}
                    <tr>
                      <td
                        className="td-other-product-field"
                        colSpan={8}
                        style={{ padding: 0, border: 0 }}
                      >
                        <div
                          ref={contentRef}
                          style={{
                            maxHeight: openRow === u.CP_ID ? "200px" : "0px",
                            opacity: openRow === u.CP_ID ? 1 : 0,
                            overflow: "hidden",
                            transition:
                              "max-height 0.4s ease, opacity 0.3s ease",
                          }}
                          className="other-collapse-content"
                        >
                          <div>
                            <p>
                              {" "}
                              <strong>Gender:</strong>
                              {u.CP_Gender === "other"
                                ? "Prepare not to say"
                                : u.CP_Gender}
                            </p>
                            <p>
                              <strong>Contact Number:</strong>{" "}
                              {u.CP_Contactnumber}
                            </p>

                            <p>
                              <strong>Birthdate:</strong>{" "}
                              {dateFormatted(u.CP_Birthdate)}
                            </p>
                          </div>

                          <div>
                            <p>
                              <strong>Provider:</strong> {u.CP_Provider}
                            </p>
                            <p>
                              <strong>Date Registered:</strong>{" "}
                              {dateFormatted(u.CP_CreatedAt)}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="11"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </main>
  );
}

export default _User;
